module.exports = __webpack_public_path__ + "img/DIVINATION_HOUSE.642e0011.png";